import React, { useEffect, useState } from 'react'
import { SetCategoriesArea } from '../components/master'
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from '../components/UIkit';
import { saveCategories } from "../reducks/categories/operations";
import { getCategories } from "../reducks/categories/selectors";


const CategoriesEdit = () => {
    const dispatch = useDispatch();
    //const [newCategories,setNewCategories] = useState([]);
    //const selector = useSelector(state  => state);
    const categoriesOnFirestore = useSelector(getCategories);
    const [categories, setCategories] = useState(categoriesOnFirestore);
    useEffect(() => {
        /*const fetchCategories = async () => {
            const q = query(collection(db, 'categories'), orderBy('cid', 'asc'));
            const querySnapshot = await getDocs(q);
            const list = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                list.push({
                    id:data.id,
                    cid: data.cid,
                    name: data.name,
                });
            });
            setCategories(list);
        };
        fetchCategories();*/
    }, []);
    // const commitCategories =  () =>{
    //     dispatch(saveCategories(categories));
    // }

  return (
    <section>
        <h2 className="u-text__headline u-text-center">カテゴリーの登録・編集</h2>
        <div className="c-section-container">
            <SetCategoriesArea categories={categories} setCategories={setCategories}/>
        </div>
        <div className="module-spacer--small"/>
            <div className="center">
                <PrimaryButton
                    label={"上書き保存"}
                     onClick={()=> dispatch(saveCategories(categories))}
                />
            </div>
    </section>

  )
}

export default CategoriesEdit